var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"checkin"},[_c('br'),_c('DatiCheckIn',{attrs:{"reservation":_vm.reservation}}),_c('br')],1)}
var staticRenderFns = []

export { render, staticRenderFns }